import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://mrgsfqhomimhmmvunenw.supabase.co';
const SUPABASE_KEY = 'sb_publishable_YySshGt6Y3skAAwKGy7lbg_3pzlvMD4';

const customStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key) || localStorage.getItem('remil-auth');
    } catch { return null; }
  },
  setItem: (key, value) => {
    try { localStorage.setItem(key, value); localStorage.setItem('remil-auth', value); } catch {}
  },
  removeItem: (key) => {
    try { localStorage.removeItem(key); localStorage.removeItem('remil-auth'); } catch {}
  },
};

// Safari/WebKit kopan baglantilarda istegi otomatik tekrar dener
const tekrarliFetch = async (input, init) => {
  const bekle = [300, 800];
  for (let i = 0; ; i++) {
    try {
      return await fetch(input, init);
    } catch (err) {
      if (err && err.name === 'AbortError') throw err;
      if (i >= bekle.length) throw err;
      await new Promise((r) => setTimeout(r, bekle[i]));
    }
  }
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  global: { fetch: tekrarliFetch },
  auth: {
    persistSession: true,
    storageKey: 'remil-auth',
    storage: customStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
